<template>
  <v-card
    class="ma-0 pa-0"
    style="overflow: hidden"
    height="calc(100vh - 50px)"
  >
    <WindowFrame
      class="ma-0 pa-0"
      referrerpolicy="origin"
      ref="windowframe_magazzino"
      :component="'magazzino'"
      :route="'/magazzino/trasferimenti'"
      :input_args="input_args"
      @click_chiudi="goBack"
      @loaded="sendParamsMag"
    />
  </v-card>
</template>

<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "TrasferimentiMagazzino",
  components: { WindowFrame },
  props: ["id"],
  data() {
    return {
      input_args: { show_toolbar: false, id_articolo: this.id },
    };
  },
  mounted() {
  },
  computed: {},
  methods: {
    sendParamsMag() {
      this.$refs.windowframe_magazzino.postEvent("setparams", {
        cod_azienda: localStorage.getItem("cod_azienda"),
        id_azienda: localStorage.getItem("id_azienda"),
        route: "/magazzino/trasferimenti",
      });
    },

    goBack() {
      this.$router.push("/home/giacenze-magazzino");
    },
  },
};
</script>